/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'underscore',
	'@ba/ba-ui-carbon',
	'@waca/dashboard-livewidget/js/widgets/livewidget/nls/StringResources'
], function(React, PropTypes, Toolkit, _, Carbon, StringResources) {
	const { FlexLayout, RadioGroup, Label } = Toolkit;
	const { Dropdown } = Carbon;

	class NavigationComponent extends React.Component {
		static propTypes = {
			possibleItems: PropTypes.array.isRequired,
			eventHandlers: PropTypes.object.isRequired
		};

		constructor(props) {
			super(props);
			let navPath = props.possibleItems[0].selectedNavigationPath;
			let itemsInPath = props.possibleItems[0].navigationPaths.find(path => path.identifier === navPath.identifier);

			this.state = {
				selectedPath: navPath,
				selectedDataItem: props.possibleItems[0].dataItem.getColumnId(),
				possibleItems: this._addParameters((itemsInPath && itemsInPath.segment) || props.possibleItems[0].navigationPaths[0].segment),
				drillGroups: this._createDrillGroupList(props.possibleItems[0].navigationPaths)
			};
		}

		onPathChange(state) {
			let newPath = this.state.drillGroups.find((path) => path.getIdentifier() == state.selectedItem.identifier);

			this.props.eventHandlers.setNavigationPathIdForDataItem(newPath.getIdentifier());

			this.setState({
				selectedPath: newPath,
				possibleItems: this.getColumnsFromPathId(newPath)
			});
		}

		onDataItemChange(item) {
			let navigateTo = _.map(this.props.possibleItems, function(possibleItem) {
				return {
					slot: possibleItem.slot,
					indexInSlot: possibleItem.indexInSlot,
					newColumnId: item,
					navigationPathId: this.state.selectedPath.identifier
				};
			}, this);
			this.props.eventHandlers.navigateTo(navigateTo);

			this.setState({
				selectedDataItem: item,
				drillGroups: this.getNavigationPathsFromDataItemId(item)
			});
		}

		getColumnsFromPathId(path) {
			return this._addParameters(path.segment);
		}

		_addParameters(possibleItems) {
			for (var i = 0; i < possibleItems.length; i++) {
				possibleItems[i].id = possibleItems[i].ref;
				possibleItems[i].value = possibleItems[i].ref;
				possibleItems[i].localizedString = possibleItems[i].label;
			}
			return possibleItems;
		}

		_createDrillGroupList(drillGroups) {
			for (var i = 0; i < drillGroups.length; i++) {
				drillGroups[i].value = drillGroups[i].getIdentifier();
			}
			return drillGroups;
		}

		getNavigationPathsFromDataItemId(dataItemId) {
			const navigationPaths = this.props.eventHandlers.getNavigationPaths(dataItemId) || [];
			const drillGroupsFromModule = this.props.eventHandlers.getDrillGroups(dataItemId) || [];
			// when navigate from the custom group column to original column, the dynamically created navigation path is missing for the original column
			// when navigate from the original column to the custom group column, the navigation path is dynamically create again
			// so when the drillGroups model from module has different length than the drillGroups model from the navigateAction, means navigate path got dynamically created
			if (this.state.drillGroups && this.state.drillGroups.length > 0 && navigationPaths.length === drillGroupsFromModule.length) {
				const customDrillGroupCandidate = this.state.drillGroups[0];
				// the dynamically created drill group for custom group will always be the first one, check if the first drill group consists by current column
				if (_.filter(customDrillGroupCandidate.getSegment(), segment => { return segment.getRef() === dataItemId; }).length > 0) {
					// check if the first drill group can not be found from the drill groups getting from the module
					if (!_.filter(drillGroupsFromModule, drillGroup => { return drillGroup.getIdentifier() === customDrillGroupCandidate.getIdentifier(); }).length) {
						// only custom group navigation path is dynamically created and not part of the drillGroups model from module
						return [customDrillGroupCandidate].concat(navigationPaths);
					}
				}
			}
			return this._createDrillGroupList(navigationPaths);
		}

		render() {
			let columnOptions = this.state.possibleItems.map((item) => {
				return {
					value: item.ref,
					checked: item.value === this.state.selectedDataItem,
					label: item.localizedString
				};
			});

			return(<FlexLayout className='navigate-dialog' justifyContent='center' direction='column'>
				<Dropdown
					disabled={this.state.drillGroups.length == 1}
					className='navigate-select'
					id='navigateSelect'
					titleText={StringResources.get('navigateSelectPath')}
					onChange={(item) => this.onPathChange(item)}
					items={this.state.drillGroups}
					light={true}
					selectedItem={ this.state.selectedPath }/>
				<Label id='columnRadioGroup' label={StringResources.get('navigateSelectColumn')} type='caption' style={{ marginTop: '16px' }}/>
				<RadioGroup
					checked={this.state.selectedDataItem}
					direction='vertical'
					onChange={(item) => this.onDataItemChange(item)}
					options={columnOptions}
					aria-labelledby='columnRadioGroup' />
			</FlexLayout>);
		}
	}

	return NavigationComponent;
});
